/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Photos_YetInputs */

const en_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No photos yet`)
};

const es_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay fotos`)
};

const fr_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune photo pour le moment`)
};

const de_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Fotos`)
};

const ja_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`まだ写真はありません`)
};

const zh_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无照片`)
};

const ar_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد صور بعد`)
};

const id_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada foto`)
};

const it_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessuna foto`)
};

const ru_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пока нет фотографий`)
};

const pt_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda sem fotos`)
};

const ko_no_photos_yet = /** @type {(inputs: No_Photos_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아직 사진이 없습니다`)
};

/**
* | output |
* | --- |
* | "No photos yet" |
*
* @param {No_Photos_YetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_photos_yet = /** @type {((inputs?: No_Photos_YetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Photos_YetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_photos_yet(inputs)
	if (locale === "es") return es_no_photos_yet(inputs)
	if (locale === "fr") return fr_no_photos_yet(inputs)
	if (locale === "de") return de_no_photos_yet(inputs)
	if (locale === "ja") return ja_no_photos_yet(inputs)
	if (locale === "zh") return zh_no_photos_yet(inputs)
	if (locale === "ar") return ar_no_photos_yet(inputs)
	if (locale === "id") return id_no_photos_yet(inputs)
	if (locale === "it") return it_no_photos_yet(inputs)
	if (locale === "ru") return ru_no_photos_yet(inputs)
	if (locale === "pt") return pt_no_photos_yet(inputs)
	return ko_no_photos_yet(inputs)
});